export default __webpack_public_path__ + "static/media/airbnb.8c22806f.svg";